import {
  useEffect,
  useLayoutEffect,
  useState,
  useCallback,
  useRef,
} from 'react';
import { useLocation } from 'react-router-dom';
import { isToday, parse } from 'date-fns';

import {
  getYoyakuInfo,
  cancelYoyaku,
  GetYoyakuSbtList,
  openSystem,
  checkHeartbeat,
  setSysForWH, //2024.09 COMTEC kawaji ADD
} from '../logics/apiLogic';
import {
  getYoyakuKbn,
  ReceiveTeihoReceptionType,
  ReceiveEventReceptionType,
  inputInfo,
  Job,
  NavigateState,
  YoyakuSbtKbn,
  ComCubeConnectSbtList,
} from '../types/teikihoan/commonDefinition';
import { usePageNavigate } from './usePageNavigate';

type yoyakuSbtList = {
  name: string;
  key: string;
};

export const useResevation = () => {
  const [yoyakuSbtList, setYoyakuSbtList] = useState<yoyakuSbtList[]>([]);
  const [yoyakuSearchInfo, setYoyakuSearchInfo] = useState<{
    uketsuke_no: string;
    yoyaku_sbt_cd: YoyakuSbtKbn;
  }>({ uketsuke_no: '', yoyaku_sbt_cd: YoyakuSbtKbn.nodata }); // 予約情報
  const [customerInfo, setCustomerInfo] = useState<inputInfo | null>(null);
  const [errorMsg, setErrorMsg] = useState<string>(''); // エラーメッセージ
  const [getDataMsg, setGetDataMsg] = useState<string>(''); // メッセージ
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [digOpen, setDigOpen] = useState<boolean>(false); // ダイアログ表示フラグ
  //2024.09 COMTEC kawaji MOD START
  // const [yoyakuIsToday, setYoyakuIsToday] = useState<boolean>(false); // 本日受付フラグ
  const [yoyakuIsToday, setYoyakuIsToday] = useState<{
    isToday: boolean;
    text: string;
  }>({ isToday: false, text: '' }); // 本日受付フラグ
  const [displayRirekiLink, setDisplayRirekiLink] = useState<{
    isDisplay: boolean;
    link: string;
  }>({ isDisplay: false, link: '' }); // 履歴リンク表示フラグ
  //2024.09 COMTEC kawaji MOD END
  const nosRef = useRef<{ customerNo: string; kyokyusakiNo: string }>({
    customerNo: '',
    kyokyusakiNo: '',
  });
  const [eGuid, setEGuid] = useState<string>(''); //2024.09 COMTEC kawaji ADD

  const location = useLocation();
  const { menuPage } = usePageNavigate();
  const params = location.state;

  /****************************************
   * 予約種別リスト取得
   ****************************************/
  const yoyakuList = useCallback(async () => {
    const data = await GetYoyakuSbtList();
    if (data.result === 0) {
      const yList = data.yoyaku_sbt_list.map(
        (row: {
          job_sbt_cd: string;
          job_sbt_name: string;
          display_sgn: boolean;
          display_no: number;
        }) => {
          return { name: row.job_sbt_name, key: row.job_sbt_cd };
        }
      );
      setYoyakuSbtList(yList);
    } else {
      setErrorMsg('サービスの一覧が取得できませんでした。');
      setYoyakuSbtList([]);
    }
  }, []);

  /****************************************
   * 予約情報セット
   * @param data
   * @returns
   ****************************************/
  const setYoyakuCustomerInfo = useCallback(
    (data: any) => {
      if (data === null) {
        setCustomerInfo(null);
        return;
      }

      const cList = data.uketsuke_info_list ?? JSON.parse(data);
      setCustomerInfo(cList);
      DisplayKurashiRirekiLink(true); //2024.09 COMTEC kawaji ADD
    },
    [setCustomerInfo]
  );

  //2024.09 COMTEC kawaji ADD START
  /****************************************
   * うぇぶひだまりお客様情報連携用のシステム情報登録
   ****************************************/
  const InsertSysForWH = async () => {
    try {
      if (
        params.guid === undefined ||
        params.guid === null ||
        params.guid === ''
      ) {
        const param = {
          transition_source: params.source ?? '',
          token: params.token ?? '',
          event_sbt_cd: params.event_sbt ?? '',
          step: 0,
          from_page: 'e-rsv',
        };
        const data = await setSysForWH(param);
        if (data.result !== 0) {
          throw new Error('error');
        }
        setEGuid(data.guid);
      }
    } catch (e) {
      console.log(e);
    }
  };
  //2024.09 COMTEC kawaji ADD END

  /****************************************
   * レンダリング前処理
   ****************************************/
  useLayoutEffect(() => {
    //サービスリスト取得
    yoyakuList();
    //ログイン用にシステム情報を登録
    InsertSysForWH(); //2024.09 COMTEC kawaji ADD
  }, []);

  /****************************************
   * レンダリング後処理
   ****************************************/
  useEffect(() => {
    // 予約情報セット
    if (params?.yoyakudata) {
      setYoyakuCustomerInfo(params.yoyakudata);
      setYoyakuSearchInfo({
        yoyaku_sbt_cd: getYoyakuKbn(params.gyomu),
        uketsuke_no: params.uketsuke_no ?? '',
      });
    }
    nosRef.current = {
      customerNo: params.customer_no,
      kyokyusakiNo: params.kyokyusaki_no,
    };
    //2024.09 COMTEC kawaji ADD START
    if (
      params?.msg !== undefined &&
      params?.msg !== null &&
      params?.msg !== ''
    ) {
      setGetDataMsg(params.msg);
      setYoyakuSearchInfo({
        yoyaku_sbt_cd: getYoyakuKbn(params.gyomu),
        uketsuke_no: params.uketsuke_no ?? '',
      });
      DisplayKurashiRirekiLink(true); //2024.09 COMTEC kawaji ADD
    }

    if (params.uketsuke_no !== '' && !params.guid && params.guid !== '') {
      setYoyakuSearchInfo({
        yoyaku_sbt_cd: getYoyakuKbn(params.gyomu),
        uketsuke_no: params.uketsuke_no ?? '',
      });
    }
    //2024.09 COMTEC kawaji ADD END
  }, []);

  useEffect(() => {
    if (customerInfo === null) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 1000);
    }
  }, [customerInfo]);
  /****************************************
   * 戻るボタンクリック
   ****************************************/
  const handlePrevClick = useCallback(async () => {
    if (params?.prepage === 'menu') {
      menuPage(params);
    } else {
      const param = {
        ...params,
        step: 0,
        function: 'teikihoan',
      };
      const result = await openSystem(param);
      if (result.result === 0) {
        window.location.replace(result.redirect_url);
      }
    }
  }, [params]);

  /****************************************
   * 確認ボタンクリック
   * @param e
   ****************************************/
  const handleGetYoyakuInfo = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      try {
        e.preventDefault();
        //2024.08.27 COMTEC kawaji ADD START
        setGetDataMsg('');
        setYoyakuCustomerInfo(null);

        if (yoyakuSearchInfo.yoyaku_sbt_cd === YoyakuSbtKbn.nodata) {
          setErrorMsg('サービスを選択してください。');
          return;
        }
        if (yoyakuSearchInfo.uketsuke_no === '') {
          setErrorMsg('受付番号を入力してください。');
          return;
        }
        if (yoyakuSearchInfo.uketsuke_no.length !== 10) {
          //2024.09 COMTEC kawaji MOD START
          //setErrorMsg('受付番号は10桁の数字を入力してください。');
          const uketukeText =
            yoyakuSearchInfo.yoyaku_sbt_cd === YoyakuSbtKbn.teikihoan
              ? '数字'
              : '英数字';
          setErrorMsg(`受付番号は10桁の${uketukeText}を入力してください。`);
          //2024.09 COMTEC kawaji MOD END
          return;
        }
        //2024.08.27 COMTEC kawaji ADD END

        //2024.09 COMTEC kawaji MOD START
        // //ComCubeと接続する必要があるサービスの場合、ComCubeへ疎通確認を行う
        // if (
        //   ComCubeConnectSbtList.includes(
        //     yoyakuSearchInfo.yoyaku_sbt_cd as YoyakuSbtKbn
        //   )
        // ) {
        //   if (yoyakuSearchInfo.uketsuke_no !== '') {
        //     if (!(await JudgeHeartbeat(yoyakuSearchInfo.uketsuke_no))) return;
        //   }
        // }

        // 予約情報取得前処理
        switch (yoyakuSearchInfo.yoyaku_sbt_cd) {
          case YoyakuSbtKbn.teikihoan:
            //ComCubeと接続する必要があるサービスの場合、ComCubeへ疎通確認を行う
            if (
              ComCubeConnectSbtList.includes(
                yoyakuSearchInfo.yoyaku_sbt_cd as YoyakuSbtKbn
              )
            ) {
              if (yoyakuSearchInfo.uketsuke_no !== '') {
                if (!(await JudgeHeartbeat(yoyakuSearchInfo.uketsuke_no)))
                  return;
              }
            }

            break;
          case YoyakuSbtKbn.event:
            //うぇぶひだまりのログインチェック、ログインしていない場合はログイン画面へ遷移
            if (
              params.guid === undefined ||
              params.guid === null ||
              params.guid === ''
            ) {
              //リクエストするAPIのURLをセット
              const form = e.currentTarget;
              const actionApi: string = process.env
                .REACT_APP_WEB_HIDAMARI_LOGIN_API as string;
              form.action = actionApi;

              //ログイン後に実行されるAPIのURLをセット
              const rollbackApi: string =
                process.env.REACT_APP_API_BASE_URL +
                'event_wh?guid=' +
                eGuid +
                '&uketsukeNo=' +
                yoyakuSearchInfo.uketsuke_no +
                '&page=e-rsv';
              const input = form.elements.namedItem(
                'rollback'
              ) as HTMLInputElement;
              input.value = rollbackApi;

              //実行
              form.submit();
              return;
            }
            break;
        }

        //2024.09 COMTEC kawaji MOD END
        setIsLoading(true);
        setYoyakuCustomerInfo(null);
        setErrorMsg('');
        setGetDataMsg('');

        //2024.09 COMTEC kawaji MOD START
        //const data = await getYoyakuInfo(yoyakuSearchInfo);
        const getYoyakuParam = { ...yoyakuSearchInfo, guid: params.guid ?? '' };
        const data = await getYoyakuInfo(getYoyakuParam);
        //2024.09 COMTEC kawaji MOD END
        if (data.result === 0) {
          // 予約情報取得成功
          setYoyakuCustomerInfo(data);
          nosRef.current = {
            customerNo: data.customer_no,
            kyokyusakiNo: data.kyokyusaki_no,
          };
          const yoyakuDay = parse(
            data.sagyo_yotei_ymd as string,
            'yyyy/MM/dd',
            new Date()
          );
          // 予約日が本日の場合、予約変更、キャンセルボタンを非活性化する
          if (isToday(yoyakuDay)) {
            //2024.09 COMTEC kawaji MOD START
            // setYoyakuIsToday(true);

            let todayWarningText = '';
            switch (yoyakuSearchInfo.yoyaku_sbt_cd) {
              case YoyakuSbtKbn.teikihoan:
                todayWarningText =
                  '申し訳ございませんが、定期保安調査当日の予約変更の受付は電話のみとなります。お手数ですが、日本ガスカスタマーサポート（099-224-5232）までご連絡ください。';
                break;
              case YoyakuSbtKbn.event:
                todayWarningText =
                  '当日の予約変更・キャンセルは受け付けておりません。\\n当日キャンセルのご連絡、その他のお問い合わせはこちらまで\\n日本ガス ガス展事務局：ei-kikaku@nihongas.co.jp';
                break;
            }
            setYoyakuIsToday({ isToday: true, text: todayWarningText });
            //2024.09 COMTEC kawaji MOD END
          } else {
            //2024.09 COMTEC kawaji MOD START
            // setYoyakuIsToday(false);
            setYoyakuIsToday({ isToday: false, text: '' });
            //2024.09 COMTEC kawaji MOD END
          }
        } else if (data.result === 9) {
          // 予約情報なし
          setGetDataMsg(data.error_message);
          DisplayKurashiRirekiLink(true); //2024.09 COMTEC kawaji ADD
        } else {
          // 予約情報取得エラー
          setErrorMsg('予約情報が取得できませんでした。');
        }
      } catch (e: any) {
        if (e.code === 'ECONNABORTED') {
          setErrorMsg(
            '一定時間経過したため、情報が取得できませんでした。もう一度始めからやり直してください。'
          );
        } else {
          setErrorMsg(
            '情報取得に失敗しました。もう一度始めからやり直してください。'
          );
        }
      } finally {
        setIsLoading(false);
      }
    },
    [yoyakuSearchInfo]
  );

  /****************************************
   * 予約変更ボタンクリック
   * @param e
   ****************************************/
  const handleYoyakuChange = useCallback(
    async (e: React.FormEvent<HTMLButtonElement>) => {
      e.preventDefault();
      let cusNo = '';
      //ComCubeと接続する必要があるサービスの場合、ComCubeへ疎通確認を行う
      if (
        ComCubeConnectSbtList.includes(
          yoyakuSearchInfo.yoyaku_sbt_cd as YoyakuSbtKbn
        )
      ) {
        cusNo =
          nosRef.current.customerNo !== ''
            ? nosRef.current.customerNo
            : params.customer_no;
        //Comcube疎通確認
        if (!(await JudgeHeartbeat(cusNo))) return;
      }
      let param: NavigateState = {
        source: params.source,
        token: params.token,
        mailaddress: params.mailaddress ?? '',
        gyomu: params.gyomu,
      };
      switch (yoyakuSearchInfo.yoyaku_sbt_cd) {
        case YoyakuSbtKbn.teikihoan:
          param = {
            ...param,
            step: 2,
            prepage: params.prepage,
            customer_no: cusNo,
            kyokyusaki_no:
              nosRef.current.kyokyusakiNo !== ''
                ? nosRef.current.kyokyusakiNo
                : params.kyokyusaki_no,
            function: Job.Teikihoan,
            gyomu: Job.Teikihoan,
          };
          break;

        case YoyakuSbtKbn.event:
          const eSbt =
            yoyakuSearchInfo.uketsuke_no.substring(0, 1) === 'H'
              ? '001'
              : '002';
          param = {
            ...param,
            uketsuke_no: yoyakuSearchInfo.uketsuke_no,
            step: 1,
            function: Job.Event,
            gyomu: Job.Event,
            event_sbt: eSbt,
            guid: params.guid ?? '', //2024.09 COMTEC kawaji ADD
          };
          break;
      }

      const result = await openSystem(param);
      if (result.result === 0) {
        window.location.replace(result.redirect_url);
      }
    },
    [params, yoyakuSearchInfo]
  );

  /****************************************
   * キャンセルボタンクリック
   ****************************************/
  const handleCancelClick = useCallback(async () => {
    //ComCubeと接続する必要があるサービスの場合、ComCubeへ疎通確認を行う
    if (
      ComCubeConnectSbtList.includes(
        yoyakuSearchInfo.yoyaku_sbt_cd as YoyakuSbtKbn
      )
    ) {
      //Comcube疎通確認
      if (
        !(await JudgeHeartbeat(
          nosRef.current.customerNo !== ''
            ? nosRef.current.customerNo
            : params.customer_no
        ))
      )
        return;
    }
    //ダイアログ表示
    setDigOpen(true);
  }, [yoyakuSearchInfo]);

  /****************************************
   * 予約キャンセル処理
   * @param e
   ****************************************/
  const onYoyakuCancel = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      try {
        e.preventDefault();
        setIsLoading(true);

        //#region 2024.09 COMTEC kawaji DEL START
        // let teihoParam: ReceiveTeihoReceptionType | null = null;
        // let eventParam: ReceiveEventReceptionType | null = null;
        // switch (yoyakuSearchInfo.yoyaku_sbt_cd) {
        //   case YoyakuSbtKbn.teikihoan:
        //     teihoParam = {
        //       token: params.token,
        //       is_web_hidamari_entry: false,
        //       customer_no:
        //         nosRef.current.customerNo !== ''
        //           ? nosRef.current.customerNo
        //           : params.customer_no,
        //       kyokyusaki_no:
        //         nosRef.current.kyokyusakiNo !== ''
        //           ? nosRef.current.kyokyusakiNo
        //           : params.kyokyusaki_no,
        //       request_date_day: '',
        //       request_date_time: '',
        //       request_date_time_cd: '',
        //       tachiaisha_kbn_name: '',
        //       tachiaisha_kbn_cd: '',
        //       tachiaisha_name: '',
        //       tachiaisha_phone_no: '',
        //       customer_name: '',
        //       customer_name_kana: '',
        //       post_no: '',
        //       gyosei_shi_ku_name: '',
        //       gyosei_cho_name: '',
        //       chomoku_banchi: '',
        //       heya_no: '',
        //       tel_no: '',
        //       mail_address: '',
        //       encrypt_mail_address: params.mailaddress ?? '',
        //       transition_source: params.source,
        //       tenken_yotei_eigyosho_cd: '',
        //       yoyaku_sbt_cd: yoyakuSearchInfo.yoyaku_sbt_cd as YoyakuSbtKbn,
        //       sakujo_sgn: true,
        //     };
        //     break;

        //   case YoyakuSbtKbn.event:
        //     eventParam = {
        //       token: params?.token ?? '',
        //       uketsuke_no: yoyakuSearchInfo.uketsuke_no ?? '',
        //       p_customer_no: '',
        //       yoyaku_sbt_cd: YoyakuSbtKbn.event,
        //       event_sbt_cd: params?.sbt ?? '',
        //       event_no: '',
        //       request_date_day_cd: 0,
        //       request_date_time_cd: 0,
        //       customer_name: '',
        //       customer_name_kana: '',
        //       customer_family_name: '',
        //       customer_first_name: '',
        //       customer_family_name_kana: '',
        //       customer_first_name_kana: '',
        //       attendance: 0,
        //       attendance_adults: 0,
        //       attendance_kids: 0,
        //       remarks: '',
        //       event_status_cd: '',

        //       post_no: '',
        //       gyosei_shi_ku_name: '',
        //       gyosei_cho_name: '',
        //       chomoku_banchi: '',
        //       heya_no: '',
        //       tel_no: '',
        //       mail_address: '',
        //       transition_source: '',
        //       sakujo_sgn: true,
        //     };
        //     break;
        // }
        //#endregion 2024.09 COMTEC kawaji DEL END

        const result = await cancelYoyaku(
          yoyakuSearchInfo.uketsuke_no,
          yoyakuSearchInfo.yoyaku_sbt_cd,
          //2024.09 COMTEC kawaji MOD START
          // teihoParam,
          // eventParam
          params.source,
          params?.token
          //2024.09 COMTEC kawaji MOD END
        );
        if (result.result === 0) {
          setGetDataMsg('予約をキャンセルしました。');
          setYoyakuCustomerInfo(null);
          params.yoyakudata = null;
          setYoyakuSearchInfo({
            uketsuke_no: '',
            yoyaku_sbt_cd: YoyakuSbtKbn.nodata,
          });
        } else {
          setErrorMsg('予約キャンセルに失敗しました。');
        }
      } catch (e) {
        console.log(e);
      } finally {
        setIsLoading(false);
        setDigOpen(false);
      }
    },
    [params, yoyakuSearchInfo]
  );

  /****************************************
   * サービスセレクトボックス変更
   * @param e
   ****************************************/
  const handleSelectChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      setYoyakuSearchInfo({
        ...yoyakuSearchInfo,
        yoyaku_sbt_cd: e.target.value as YoyakuSbtKbn,
      });
      DisplayKurashiRirekiLink(false); //2024.09 COMTEC kawaji ADD
    },
    [yoyakuSearchInfo]
  );

  /****************************************
   * 予約番号入力変更
   * @param e
   ****************************************/
  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setYoyakuSearchInfo({
        ...yoyakuSearchInfo,
        uketsuke_no: e.target.value,
      });
    },
    [yoyakuSearchInfo]
  );

  /****************************************
   * Comcube疎通確認
   * @param no　お客さま番号　または　受付番号
   ****************************************/
  const JudgeHeartbeat = async (no: string) => {
    const chkHB = await checkHeartbeat({
      judgement_no: no,
    });
    if (chkHB.result !== 0) {
      menuPage(params);
      return false;
    }

    return true;
  };

  //2024.09 COMTEC kawaji ADD START
  /****************************************
   * 暮らしサービス履歴リンク表示・非表示
   * @param no　お客さま番号　または　受付番号
   ****************************************/
  const DisplayKurashiRirekiLink = useCallback(
    (value: boolean) => {
      setDisplayRirekiLink({
        isDisplay: value,
        link: value
          ? (process.env.REACT_APP_WEB_HIDAMARI_RIREKI_URL as string)
          : '',
      });
    },
    [displayRirekiLink]
  );
  //2024.09 COMTEC kawaji ADD END

  return {
    yoyakuSbtList,
    yoyakuSearchInfo,
    customerInfo,
    errorMsg,
    getDataMsg,
    isLoading,
    digOpen,
    yoyakuIsToday,
    displayRirekiLink, //2024.09 COMTEC kawaji ADD
    handlePrevClick,
    handleGetYoyakuInfo,
    handleYoyakuChange,
    handleCancelClick,
    onYoyakuCancel,
    handleSelectChange,
    handleInputChange,
    setDigOpen,
  };
};
